export type KeyboardShortcut = {
    category: string;
    shortcuts: {
        keys: string | string[];
        description: string;
    }[];
};

export const KEYBOARD_SHORTCUTS: KeyboardShortcut[] = [
    {
        category: 'Quick access',
        shortcuts: [
            {keys: 'g c', description: 'Go to companies'},
            {keys: 'g p', description: 'Go to people'},
            {keys: 'g l', description: 'Go to leads'},
            {keys: 'g r', description: 'Go to reports'},
            {keys: 'g a', description: 'Go to add new menu'},
            {keys: 'g n', description: 'Go to notifications'},
            {keys: 'g u', description: 'Go to user menu'},
            {keys: 'g s', description: 'Go to settings'},
        ],
    },
    {
        category: 'Create new',
        shortcuts: [
            {keys: 'c c', description: 'Create new company'},
            {keys: 'c p', description: 'Create new person'},
            {keys: 'c l', description: 'Create new lead'},
            {keys: 'c t', description: 'Create new task'},
            {keys: 'c a', description: 'Create new activity'},
        ],
    },
    {
        category: 'Navigation',
        shortcuts: [
            {keys: ['/', '⌘+k'], description: 'Open search'},
            {keys: ['ctrl+/', '⌘+/'], description: 'Toggle sidebar collapse'},
        ],
    },
    {
        category: 'Suite navigation',
        shortcuts: [
            {keys: 'g 1', description: 'Go to sales'},
            {keys: 'g 2', description: 'Go to marketing'},
            {keys: 'g 3', description: 'Go to engagement'},
        ],
    },
];
